import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';

// import { useHistory } from 'react-router';
import * as AppPropTypes from '../../lib/PropTypes';

import { useUrlGenerator } from '../../contexts/RoutesContext';
import ExitIcon from '../icons/Exit';
import IconLink from './IconLink';

import styles from '../../../styles/partials/user-placeholder.module.scss';

const propTypes = {
    user: AppPropTypes.user,

    className: PropTypes.string,
};

const defaultProps = {
    user: null,
    className: null,
};

const UserPlaceholder = ({ user = null, className }) => {
    const route = useUrlGenerator();
    const [showDisclaimer, setShowDisclaimer] = useState(false);
    // const history = useHistory();

    useEffect(() => {
        const id = setTimeout(() => {
            setShowDisclaimer(true);
        }, 1500);
        return () => {
            clearTimeout(id);
        };
    }, [user]);

    return (
        <div
            className={classNames(styles.container, {
                [className]: className !== null,
                [styles.visible]: showDisclaimer,
            })}
        >
            <div className={styles.inner}>
                <p className={styles.paragraph}>
                    <FormattedMessage defaultMessage="User not found" description="Button label" />
                </p>
                <IconLink
                    className={styles.button}
                    icon={<ExitIcon />}
                    href={route('login')}
                    isDark
                >
                    <FormattedMessage
                        defaultMessage="Go back to login"
                        description="Button label"
                    />
                </IconLink>
            </div>
        </div>
    );
};

UserPlaceholder.propTypes = propTypes;
UserPlaceholder.defaultProps = defaultProps;

export default UserPlaceholder;
